import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { pageTitle } from '../../helper'
import Button from '../Button'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import Spacing from '../Spacing'

const WHATSAPP_NUMBER = '971544905157';

const portfolioDetails = {
  'greenpay-wallet': {
    title: 'GreenPay Digital Wallet – Super App Platform',
    subtitle: 'Fintech & Digital Services',
    image: '/images/greenpay-wallet-app.png',
    description: 'GreenPay Digital Wallet is a multifunctional mobile super app that combines digital wallet capabilities with a wide range of everyday services in a single platform. The application enables users to manage their wallet balance, make payments, access travel and ticketing services, and use various integrated digital services through a unified and intuitive interface.',
    description2: 'Designed as an all-in-one solution, GreenPay Digital Wallet provides a seamless user experience across iOS and Android platforms, supporting both financial and non-financial services within one ecosystem.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, Node.js',
    year: '2023',
    features: [
      'Multifunctional mobile super app platform',
      'Digital wallet and payment management',
      'Travel and ticketing services integration',
      'Wide range of everyday services',
      'iOS and Android platforms support',
    ],
  },
  'toxo-rider': {
    title: 'TOXO Rider App — Taxi Passenger Mobile Application',
    subtitle: 'Mobility & Transportation',
    image: '/images/toxo-rider-app.png',
    description: 'TOXO Rider App is a taxi booking mobile application designed for passengers to request rides, track drivers in real time, and manage trip history through a simple and intuitive interface. The application allows users to select pickup and destination locations via an interactive map, choose ride types (Economy, Comfort, etc.), and view estimated trip prices before confirming the ride.',
    description2: 'Built for both iOS and Android, the app focuses on performance, usability, and seamless user experience, enabling fast ride requests and reliable transportation services.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, Maps API',
    year: '2022',
    features: [
      'Taxi booking mobile application',
      'Interactive map for pickup and destination',
      'Ride type selection and price estimation',
      'Real-time ride tracking',
      'Trip history and user profile management',
    ],
  },
  'toxo-driver': {
    title: 'TOXO – Taxi Driver Mobile Application',
    subtitle: 'Mobility & Transportation',
    image: '/images/toxo-driver-app.png',
    description: 'TOXO Driver is the driver-side mobile application of the TOXO ride-hailing platform, designed to help taxi drivers manage trips, earnings, and availability in real time. The application allows drivers to go online/offline, receive ride requests within a defined radius, and navigate efficiently using live map integration.',
    description2: 'A comprehensive trip history module provides detailed insights into completed rides, including dates, ride types, distances, and earnings. The earnings dashboard helps drivers analyze their income over selected time periods through clear visual charts and summaries. The app is optimized for performance and usability, ensuring smooth operation even during high-demand periods.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, Maps API',
    year: '2022',
    features: [
      'Driver-side taxi management application',
      'Online/offline status management',
      'Real-time ride request handling',
      'Live map and radius-based trip search',
      'Trip history and earnings analytics',
    ],
  },
  'reservation-platform': {
    title: 'Online Reservation Platform for Service Businesses',
    subtitle: 'Web & Mobile Booking System',
    image: '/images/online-reservation-platform.png',
    description: 'A modern online reservation system built for service businesses like barbershops, beauty salons, and personal care providers. Users can browse nearby providers, see available services, check real-time slots, and book instantly via mobile or web.',
    description2: 'Business owners manage appointments, services, schedules, and bookings from an admin panel to streamline daily operations. The platform significantly improves visibility and customer experience for service-based businesses.',
    category: 'Web & Mobile',
    platforms: 'Web, iOS, Android',
    technologies: 'React, Node.js, PostgreSQL',
    year: '2023',
    features: [
      'Web & mobile apps for booking appointments',
      'Browse providers, services, and real-time availability',
      'Instant reservations without phone calls',
      'Admin panel for services, schedules, and bookings',
      'Improved visibility and customer experience',
    ],
  },
  'emiland-app': {
    title: 'Emiland – Fashion & Suit Ordering Mobile App',
    subtitle: 'E-commerce & Fashion',
    image: '/images/emiland-app.png',
    description: 'Emiland is a mobile e-commerce application designed for ordering men\'s fashion and tailored suits, providing a seamless shopping experience across iOS and Android platforms.',
    description2: 'The application allows users to browse curated collections, explore detailed product catalogs, and place orders through a clean, elegant, and user-friendly interface tailored to the fashion industry.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, REST API',
    year: '2023',
    features: [
      'Native iOS and Android mobile applications',
      'E-commerce platform for men\'s fashion and suits',
      'Curated collections and product catalogs',
      'Seamless shopping experience',
      'Clean and elegant user interface',
    ],
  },
  'greenpay-chat': {
    title: 'GreenPay Chat – Messaging & Communication Mobile Application',
    subtitle: 'Communication Platform',
    image: '/images/greenpay-chat-app.png',
    description: 'GreenPay Chat is a full-featured mobile messaging application designed to support real-time communication across iOS and Android platforms. The application enables users to communicate through instant messaging, voice calls, video calls, and stories.',
    description2: 'With a clean and intuitive interface, GreenPay Chat supports both personal and group communication while ensuring smooth performance and usability, providing a unified and modern communication experience within a single platform.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, WebSocket',
    year: '2023',
    features: [
      'Full-featured mobile messaging application',
      'Real-time communication on iOS and Android',
      'Instant messaging, voice and video calls',
      'Stories feature and group communication',
      'Clean and intuitive interface',
    ],
  },
  'raffe-app': {
    title: 'Raffe App',
    subtitle: 'Digital Raffles & Rewards',
    image: '/images/raffe-app.png',
    description: 'Raffe App is a mobile application designed for digital raffles and prize-based campaigns, allowing users to participate in draws, win rewards, and manage tickets through a unified platform.',
    description2: 'The application enables users to purchase raffle entries at low cost, track active and expired tickets, manage wallet balances, and participate in live draws and prize campaigns directly within the app. With a vibrant and engaging user interface, Raffe App delivers an interactive experience that combines digital rewards, wallet functionality, and real-time engagement on iOS and Android platforms.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, Node.js',
    year: '2024',
    features: [
      'Digital raffles and prize-based campaigns',
      'Participate in draws and win rewards',
      'Purchase raffle entries and manage tickets',
      'Wallet balance management',
      'iOS and Android platforms support',
    ],
  },
  'travel-booking': {
    title: 'Travel & Tour Booking Platform (Web)',
    subtitle: 'Travel & Tourism',
    image: '/images/travel-tour-booking-platform.png',
    description: 'A comprehensive travel booking website that lets users search and book tours, travel packages, and holiday offers through an intuitive web experience.',
    description2: 'Travelers can search by departure, destination, dates, guests, citizenship, and travel class, while discovering visa-free tours, seasonal campaigns, and popular destinations in one place. The responsive and modern web UI ensures a user-friendly booking flow.',
    category: 'Web Platform',
    platforms: 'Web',
    technologies: 'React, Node.js, PostgreSQL',
    year: '2022',
    features: [
      'Travel and tour search by destination and date',
      'Guest, citizenship, and travel class selection',
      'Visa-free and seasonal tour listings',
      'Promotional travel packages and campaigns',
      'Responsive and modern web UI',
    ],
  },
  'rahatbina': {
    title: 'Building & Hotel Management System (Web & Mobile)',
    subtitle: 'Property Management',
    image: '/images/rahatbina-building-management.jpg',
    description: 'RahatBina is a comprehensive web and mobile management system designed for residential buildings and hotels to streamline daily operations, maintenance, and communication.',
    description2: 'Residents, tenants, or guests can submit service requests, report issues, and place maintenance orders online, while management teams track, assign, and monitor every task from a centralized dashboard. The system improves communication and operational transparency across buildings and hotels.',
    category: 'Web & Mobile',
    platforms: 'Web, iOS, Android',
    technologies: 'React, Node.js, MongoDB',
    year: '2021',
    features: [
      'Web & mobile apps for residents, guests, and administrators',
      'Online maintenance and service request submission',
      'Issue reporting for building and hotel facilities',
      'Task assignment and status tracking for management',
      'Centralized dashboard for full building/hotel operations',
    ],
  },
  'green-hotel': {
    title: 'Hotel – Hotel Booking Mobile Application',
    subtitle: 'Travel & Hospitality',
    image: '/images/green-hotel-app.png',
    description: 'Green Hotel is a mobile application developed for hotel search and booking, enabling users to find accommodations worldwide and complete reservations directly through the app.',
    description2: 'The application provides an intuitive booking flow, detailed hotel listings, and integrated payment functionality, offering a seamless experience for travelers on both iOS and Android platforms. Users can search hotels by location and date, view hotel details, compare prices, and finalize bookings securely within the application.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, REST API',
    year: '2023',
    features: [
      'Hotel search and booking mobile application',
      'Worldwide accommodation search',
      'Intuitive booking flow and hotel listings',
      'Integrated payment functionality',
      'iOS and Android platforms support',
    ],
  },
  'vegul-app': {
    title: 'Vegul App',
    subtitle: 'Fashion E-commerce',
    image: '/images/vegul-app.png',
    description: 'Vegul App is a mobile e-commerce application designed for bridal dresses and women\'s fashion collections, available on both iOS and Android platforms.',
    description2: 'The application allows users to explore curated bridal and fashion collections, browse products by category, view detailed product information, and manage their shopping experience through an elegant and user-friendly interface. With a strong focus on visual presentation and usability, Vegul App helps fashion brands showcase their collections digitally.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, REST API',
    year: '2022',
    features: [
      'Mobile e-commerce for bridal dresses and fashion',
      'Curated bridal and fashion collections',
      'Product browsing by category',
      'Elegant and user-friendly interface',
      'iOS and Android platforms support',
    ],
  },
  'cerene-website': {
    title: 'Cerene – Fashion E-commerce Website',
    subtitle: 'E-commerce & Fashion',
    image: '/images/cerene-website.png',
    description: 'Cerene is a custom e-commerce website developed for a premium fashion brand, focused on the online sale of exclusive clothing collections.',
    description2: 'The platform provides a clean and modern shopping experience, allowing customers to browse curated products, explore detailed collections, and complete purchases through integrated payment systems. The website is designed to reflect the brand\'s identity while ensuring smooth navigation, performance, and secure transaction handling.',
    category: 'Web Platform',
    platforms: 'Web',
    technologies: 'React, Next.js, Stripe',
    year: '2022',
    features: [
      'Custom e-commerce platform for fashion brand',
      'Premium clothing collections showcase',
      'Clean and modern shopping experience',
      'Integrated payment systems',
      'Smooth navigation and secure transactions',
    ],
  },
  'ciao-website': {
    title: 'CIAO Website – Multilingual Education & Training Platform',
    subtitle: 'Education & Training',
    image: '/images/ciao-website.png',
    description: 'CIAO Website is a web platform developed for a language and cultural education center, designed to present training programs, courses, and institutional information in multiple languages.',
    description2: 'The website allows users to explore educational offerings, learn about programs and events, and access content in different languages through a clean and user-friendly interface. Built with a strong focus on accessibility and clarity, the CIAO website supports multilingual navigation and provides an informative digital presence for an international audience.',
    category: 'Web Platform',
    platforms: 'Web',
    technologies: 'React, i18n, CMS',
    year: '2024',
    features: [
      'Multilingual education and training platform',
      'Language and cultural education center website',
      'Training programs and courses presentation',
      'Multilingual navigation and content',
      'Clean and user-friendly interface',
    ],
  },
  'pfl-website': {
    title: 'PFL — Azerbaijan Professional Football League Platform',
    subtitle: 'Sports & Media',
    image: '/images/pfl-website.png',
    description: 'A comprehensive digital platform developed for the Azerbaijan Professional Football League (PFL), serving as the official hub for national football competitions. The platform provides real-time access to match schedules and fixtures, live match broadcasts and updates, league standings and tournament tables.',
    description2: 'Designed to handle high traffic during live matches, the system ensures fast performance, accurate data synchronization, and a seamless user experience across desktop and mobile devices. The solution combines modern UI/UX design with a robust backend architecture to deliver reliable live data, scalable content management, and multilingual support.',
    category: 'Web Platform',
    platforms: 'Web',
    technologies: 'React, Node.js, WebSocket',
    year: '2024',
    features: [
      'Comprehensive football league platform',
      'Real-time match schedules and live broadcasts',
      'League standings and tournament tables',
      'Top scorers and team statistics',
      'High-performance architecture for live matches',
    ],
  },
  'emiland-website': {
    title: 'Emiland Website — Luxury Menswear Brand Platform',
    subtitle: 'Fashion & Branding',
    image: '/images/emiland-website.png',
    description: 'Emiland Website is a luxury web platform developed for a premium men\'s suit brand specializing in high-quality tailored clothing. The website showcases the brand\'s suit collections, craftsmanship, and design philosophy through a refined and elegant visual experience.',
    description2: 'Users can explore different collections, learn about fabrics and tailoring processes, and discover the brand\'s identity and heritage. Designed with a strong focus on aesthetics and brand storytelling, the platform reflects the sophistication of the Emiland brand.',
    category: 'Web Platform',
    platforms: 'Web',
    technologies: 'React, Next.js, CMS',
    year: '2023',
    features: [
      'Luxury menswear brand platform',
      'Premium suit collections showcase',
      'Craftsmanship and design philosophy presentation',
      'Refined and elegant visual experience',
      'Brand storytelling and heritage',
    ],
  },
  'superfon-website': {
    title: 'Superfon Website — Mobile Accessories E-commerce Platform',
    subtitle: 'E-commerce',
    image: '/images/superfon-website.png',
    description: 'Superfon Website is an e-commerce platform developed for the online sale of mobile accessories. The website allows users to browse and purchase a wide range of mobile accessories through a simple and user-friendly interface.',
    description2: 'It includes a secure online payment system, enabling customers to complete purchases quickly and safely. Designed to support smooth shopping flows, the platform focuses on product visibility, easy navigation, and a seamless checkout experience across desktop and mobile devices.',
    category: 'Web Platform',
    platforms: 'Web',
    technologies: 'React, Node.js, Stripe',
    year: '2021',
    features: [
      'Mobile accessories e-commerce platform',
      'Browse and purchase wide range of products',
      'Simple and user-friendly interface',
      'Secure online payment system',
      'Smooth shopping flows and checkout experience',
    ],
  },
  'b2b-loyalty': {
    title: 'Wholesale Loyalty Mobile App — B2B Ordering & Bonus Management',
    subtitle: 'B2B & Wholesale',
    image: '/images/b2b-loyalty-app.png',
    description: 'This mobile application is designed for retail stores to manage wholesale purchasing, orders, and loyalty bonuses in one centralized platform. The app allows stores to place wholesale orders directly from suppliers, track total purchases and order history.',
    description2: 'With a clear and intuitive interface, the application helps businesses control their purchasing activity, improve engagement through bonuses, and simplify daily operations. The solution is built to support scalable B2B workflows and provides full transparency over transactions, orders, and rewards.',
    category: 'Mobile App',
    platforms: 'iOS, Android',
    technologies: 'React Native, Node.js',
    year: '2024',
    features: [
      'B2B wholesale ordering and management',
      'Track purchases and order history',
      'Monitor balances and payments',
      'Earn and manage bonus points',
      'Real-time notifications and updates',
    ],
  },
  'elfim-auto': {
    title: 'ELFIM Auto Website — Automotive Parts E-commerce Platform',
    subtitle: 'Automotive & E-commerce',
    image: '/images/elfim-auto-website.png',
    description: 'ELFIM Auto Website is an automotive e-commerce platform designed for the online sale of vehicle spare parts. The platform enables users to search and purchase spare parts based on vehicle brand, model, engine specifications, product categories and manufacturers.',
    description2: 'With an advanced catalog and filtering system, customers can quickly find compatible parts for their vehicles. The website supports online purchasing, providing a streamlined ordering process for both individual and business customers.',
    category: 'Web Platform',
    platforms: 'Web',
    technologies: 'React, Node.js, PostgreSQL',
    year: '2022',
    features: [
      'Automotive parts e-commerce platform',
      'Search by brand, model, and engine specifications',
      'Advanced catalog and filtering system',
      'Compatible parts finder',
      'Streamlined ordering process',
    ],
  },
  'katech-terminal': {
    title: 'KATech Smart Terminal System',
    subtitle: 'Fintech & Self-Service',
    image: '/images/katech-terminal-system.png',
    description: 'KATech Smart Terminal System is a large-scale self-service terminal solution designed for processing high-volume financial transactions. The system enables users to make payments, manage services, and perform financial operations directly through physical terminals connected to centralized backend systems.',
    description2: 'Our team developed the core terminal software, including transaction processing logic, integration with payment and service systems, backend communication and synchronization, and secure handling of financial operations. The solution is built to support scalability, reliability, and uninterrupted operation across thousands of terminals.',
    category: 'Enterprise Solution',
    platforms: 'Terminal Software',
    technologies: 'C#, .NET, SQL Server',
    year: '2020',
    features: [
      'Large-scale self-service terminal solution',
      'High-volume financial transaction processing',
      'Payment and service management',
      'Backend communication and synchronization',
      'Scalable and reliable terminal operations',
    ],
  },
};

const projectKeys = Object.keys(portfolioDetails);

export default function PortfolioDetailsPage() {
  const params = useParams();
  const projectId = params.portfolioDetailsId;
  const project = portfolioDetails[projectId];

  pageTitle(project ? project.title : 'Portfolio Details');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [projectId]);

  const currentIndex = projectKeys.indexOf(projectId);
  const prevKey = currentIndex > 0 ? projectKeys[currentIndex - 1] : projectKeys[projectKeys.length - 1];
  const nextKey = currentIndex < projectKeys.length - 1 ? projectKeys[currentIndex + 1] : projectKeys[0];

  if (!project) {
    return (
      <>
        <PageHeading
          title="Project Not Found"
          bgSrc="/images/service_hero_bg.jpeg"
          pageLinkText="Portfolio"
        />
        <Spacing lg="150" md="80" />
        <Div className="container text-center">
          <h2>The requested project could not be found.</h2>
          <Spacing lg="30" md="20" />
          <Button btnLink="/portfolio" btnText="Back to Portfolio" />
        </Div>
        <Spacing lg="150" md="80" />
      </>
    );
  }

  return (
    <>
      <PageHeading
        title="Portfolio Details"
        bgSrc="/images/service_hero_bg.jpeg"
        pageLinkText={project.title}
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <img src={project.image} alt={project.title} className="cs-radius_15 w-100" />
        <Spacing lg="90" md="40" />
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title={project.title}
              subtitle={project.subtitle}
            >
              <Spacing lg="40" md="20" />
              <p>{project.description}</p>
              <Spacing lg="10" md="10" />
              <p>{project.description2}</p>
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-lg-1">
            <Spacing lg="60" md="40" />
            <h2 className="cs-font_30 cs-font_26_sm cs-m0">Project Info -</h2>
            <Spacing lg="50" md="30" />
            <Div className="row">
              <Div className="col-6">
                <h3 className="cs-accent_color cs-font_22 cs-font_18_sm cs-m0">Category:</h3>
                <p className="cs-m0">{project.category}</p>
                <Spacing lg="30" md="30" />
              </Div>
              <Div className="col-6">
                <h3 className="cs-accent_color cs-font_22 cs-font_18_sm cs-m0">Platforms:</h3>
                <p className="cs-m0">{project.platforms}</p>
                <Spacing lg="30" md="30" />
              </Div>
              <Div className="col-6">
                <h3 className="cs-accent_color cs-font_22 cs-font_18_sm cs-m0">Year:</h3>
                <p className="cs-m0">{project.year}</p>
                <Spacing lg="30" md="30" />
              </Div>
            </Div>
            <Spacing lg="30" md="30" />
            <h3 className="cs-accent_color cs-font_22 cs-font_18_sm cs-m0">Key Features:</h3>
            <Spacing lg="15" md="15" />
            <ul className="cs-mp0" style={{ listStyle: 'none', paddingLeft: 0 }}>
              {project.features.map((feature, i) => (
                <li key={i} style={{ marginBottom: '8px', paddingLeft: '15px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: 0, color: '#ff4a17' }}>•</span>
                  {feature}
                </li>
              ))}
            </ul>
            <Spacing lg="30" md="20" />
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`Hello, I'm interested in "${project.title}". Please share more details.`)}`}
              target="_blank"
              rel="noreferrer"
              className="cs-btn cs-style1"
              style={{ display: 'inline-flex' }}
            >
              <span><Icon icon="fa6-brands:whatsapp" style={{ marginRight: 8, fontSize: 18, verticalAlign: 'middle' }} />Get a Quote</span>
              <Icon icon="bi:arrow-right" />
            </a>
          </Div>
        </Div>
        <Spacing lg="65" md="10" />
        <Div className="cs-page_navigation cs-center">
          <Div>
            <Button btnLink={`/portfolio/${prevKey}`} btnText="Prev Project" variant="cs-type1" />
          </Div>
          <Div>
            <Button btnLink={`/portfolio/${nextKey}`} btnText="Next Project" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="145" md="80" />
      <Cta
        title="info@codewus.ae"
        bgSrc="/images/cta_bg_2.jpeg"
        variant="rounded-0"
      />
    </>
  );
}
